import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { CircularProgress, createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';

import { Button, Typography } from 'components/v2';

const messages = defineMessages({
  rescheduleAppointment: {
    id: 'components.v2.RescheduleButton.rescheduleAppointment',
    defaultMessage: 'Reschedule/Cancel Appt',
  },
});

const styles = ({ spacing }: Theme) =>
  createStyles({
    rescheduleApptBtn: {
      margin: `${spacing.unit}px 0`,
    },
  });

export interface RescheduleButtonProps extends WithStyles<typeof styles> {
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  disabled: boolean;
  isLoading?: boolean;
}

const RescheduleButton: React.FC<RescheduleButtonProps> = ({ classes, onClick, disabled, isLoading }) => {
  const { formatMessage } = useIntl();

  return (
    <Button
      data-lh-id="button-RescheduleButton"
      className={classes.rescheduleApptBtn}
      color="primary"
      variant="contained"
      disabled={disabled || isLoading}
      onClick={onClick}
      fullWidth
      extraRounded
      extraPadding
    >
      {isLoading ? (
        <CircularProgress size={21} />
      ) : (
        <Typography variant="bW600F14" color="inherit" noWrap>
          {formatMessage(messages.rescheduleAppointment)}
        </Typography>
      )}
    </Button>
  );
};

export default withStyles(styles, { name: 'RescheduleButton' })(RescheduleButton);
